// @ts-nocheck
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import PopupOpener from './components/Modals/PopupOpener';
import AlertCookie from './components/Alert/AlertCookie';
import DynamicScriptLoader from './components/Alert/DynamicScriptLoader';
import StoreProvider, { StoreContext } from './store';
import HomePage from './pages/HomePage';
import { ScrollProvider } from './store/ScrollContext';
import ProductPage from './pages/ProductPage/ProductPage';
import ArticlePage from './pages/ArticlePage';

function App(): JSX.Element {
  const hostname = window.location.hostname;
  const isBY = hostname.endsWith('.by');
  return (
    <StoreProvider>
      {/* <ScrollProvider> */}
      <Router>
        <PopupOpener />
        {/* {isBY ? <HeaderBy1 /> : <Header1 />} */}
        <Switch>
          <Route exact path="/">
            <HomePage />
          </Route>
          <Route path="/product/:enName">
            <ProductPage />
          </Route>
          <Route path="/article/:enName">
            <ArticlePage />
          </Route>
          {/* <Route path="/licence">
          <LicencePage />
        </Route> */}
        </Switch>
        {/* {isBY ? <FooterBy1 /> : <Footer1 />} */}
        <AlertCookie />
        <DynamicScriptLoader />
      </Router>
      {/* </ScrollProvider> */}
    </StoreProvider>
  );
}

export default App;
